import React, { MouseEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import deleteIcon from "../../assets/card-icons/delete.svg";
import GoLiveIcon from "../../assets/card-icons/go-live-icon.svg";
import stableIcon from "../../assets/card-icons/stable.svg";
import successOutlineIcon from "../../assets/checkmark-outlined.svg";
import failureOutlineIcon from "../../assets/close-icon.svg";
import cartBlue from '../../assets/nav-icons/cart-blue.svg';
import { getDetails, postDetails } from "../../services/http/http.service";
import { setAlertMode, setMessage, setShowAlert } from "../../store/Alert/alert.slice";
import {
  setShowCTAModal,
  setUserCartItems,
  setUserProdCartItems,
  setWishListedItems,
} from "../../store/authentication/authentication.slice";
import { showMessageOnFailure } from "../../store/error.actions";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import {
  setCart,
  setOrderTab,
  setShowSideModal,
  setSideModalOption,
} from "../../store/selectedAPIs/selectedAPIs.slice";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import {
  CardInterface
} from "../../utils/constants/Interfaces.constants";
import {
  APIResponseCodes,
  UATOrdersStatus,
} from "../../utils/constants/keys.constants";
import { message } from "../../utils/constants/Messages";
import { NavList } from "../../utils/constants/navigation";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import encrypt from "../../utils/helpers/encrypt";
import Share from "../Share/Share";
import { BillingInfoModal } from "./BillingInfo";
import "./cards.css";


const Card: React.FunctionComponent<CardInterface> = ({ list, from, callbackFunction, source }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation()

  const { cart } = useAppSelector(StoreSelectors.SELECTED_STATE);
  const { cartItems, prodCartItems, uatOrders, wishListedItems, prodOrders, access } = useAppSelector(StoreSelectors.USER_STATE);

  const [showShare, setShowShare] = useState(false)
  const [selectedID, setSelectedID] = useState('')
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [billingForm, setBillingForm] = useState({
    billing_address: "",
    authorised_signatory: "",
  });
  /** Redirects to api details page */

  console.log("location.state?.source", source);
  const handleCardClick = (api: any) => {
    if (from === 'orders') {
      console.log("LOCATIONHHJJJHH", api.remark);
      
      let status = ''
      if (api.order_state === UATOrdersStatus.onhold) status = 'warning'
      if (api.order_state === UATOrdersStatus.failed) status = 'error'

      api.remark === null ?
        navigate(`${NavList.API_DETAILS}${encodeURIComponent(encrypt(api.group_id))}`, { state: { from: 'orders', source: source,
          uatOrderProcessed: source === 'uat-orders' && api.order_state === UATOrdersStatus.processed,} })
        :
        navigate(`${NavList.API_DETAILS}${encodeURIComponent(encrypt(api.group_id))}`, { state: { from: 'orders', remark: api.remark, status: status, group_version: api.group_version, group_version_id: api.group_version_id, source: source,
          uatOrderProcessed: source === 'uat-orders' && api.order_state === UATOrdersStatus.processed,
         } })
    } else {
      navigate(`${NavList.API_DETAILS}${encodeURIComponent(encrypt(api.group_id))}`, { state: { from: location.pathname, group_version: api.group_version, group_version_id: api.group_version_id } })
    }
  };

  const handleProdClick = async (ev: MouseEvent<HTMLButtonElement>, api: any) => {

    ev.stopPropagation()
    if (prodOrders?.includes(api.group_version_id)) {
      dispatch(setOrderTab("prod"));
      navigate(NavList.ORDERS)
      return
    }
    if (prodCartItems.includes(api.group_version_id)) {
      dispatch(setSideModalOption("prod"));
      dispatch(setShowSideModal(true));
    }
    else {
      dispatch(setSideModalOption("prod"));
      dispatch(showLoader(message.ADDING_CHECKOUT));
      const billingResponse = await getDetails(APIList.USER_BILLING_DETAILS, () => handleProdClick(ev, api))
      dispatch(hideLoader())

      if (billingResponse.statusCode === APIResponseCodes.SUCCESS) {

        const data = billingResponse.data || {};

        // 🔍 Treat non-string or empty as "missing"
        const invalidType =
          typeof data.billing_address !== "string" ||
          // typeof data.gstin !== "string" ||
          // typeof data.pan !== "string" ||
          typeof data.authorised_signatory !== "string";

        const isEmpty =
          !data.billing_address?.trim()?.length ||
          // !data.gstin?.trim()?.length ||
          // !data.pan?.trim()?.length ||
          !data.authorised_signatory?.trim()?.length;

        if (invalidType || isEmpty) {
          setBillingForm({
            billing_address:
              typeof data.billing_address === "string" ? data.billing_address : "",
            authorised_signatory:
              typeof data.authorised_signatory === "string"
                ? data.authorised_signatory
                : "",
          });
          setShowBillingModal(true);
          return;
        }
      }

      try {
        const response = await postDetails(APIList.ADD_TO_PROD_CART, {
          groupId: api.group_id,
          groupVersionId: api.group_version_id
        }, () => handleProdClick(ev, api));

        if (response.statusCode === APIResponseCodes.SUCCESS) {
          dispatch(setSideModalOption("prod"));
          dispatch(setShowSideModal(true));
          dispatch(setUserProdCartItems([...prodCartItems, api.group_version_id]));
        } else dispatch(hideLoader());
      } catch (error) {
        dispatch(hideLoader());
        console.log(error);
      }
    }
  };


  const handleBillingSubmit = async (payload: {
    billing_address: string;
    authorised_signatory: string;
  }) => {

    try {
      dispatch(showLoader("Updating billing information..."));
      const response = await postDetails(APIList.USER_SAVE_BILLING_DETAILS, payload
      );

      dispatch(hideLoader());

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        setShowBillingModal(false);
        dispatch(setShowCTAModal(false))
        dispatch(setMessage("Billing information updated successfully."))
        dispatch(setAlertMode(true))
        dispatch(setShowAlert(true))
      } else {
        dispatch(showMessageOnFailure("Failed to update billing information."));
      }
    } catch (err) {
      dispatch(hideLoader());
      console.error(err);
      dispatch(showMessageOnFailure("Failed to update billing information."));
    }
  };


  /** Delete an item from cart */
  const handleCartItemDelete = async (ev: MouseEvent<HTMLButtonElement>, api: any) => {
    ev.stopPropagation()
    dispatch(showLoader(message.REMOVING_FROM_CART));
    const response = await postDetails(APIList.REMOVE_CART_ITEM, {
      groupId: api.group_id,
      groupVersionId: api.group_version_id
    }, () => handleCartItemDelete(ev, api));

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      const result = cart.filter((item: any) => item.group_version_id !== api.group_version_id);
      const ids = cartItems.filter((currentid: number) => currentid !== api.group_version_id);
      dispatch(setUserCartItems(ids));
      dispatch(setCart(result));
    }

    dispatch(hideLoader());
  };

  /** Remove an api from checkout flow */
  const handleSaveLater = async (ev: MouseEvent<HTMLButtonElement>, api: any) => {
    ev.stopPropagation()
    try {
      dispatch(showLoader(message.SAVING_LATER))
      const response = await postDetails(APIList.REMOVE_FROM_PROD_CART, {
        groupId: api.group_id,
        groupVersionId: api.group_version_id
      }, () => handleSaveLater(ev, api))
      dispatch(hideLoader())
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        const ids = prodCartItems.filter((currentid: any) => currentid !== api.group_version_id)
        dispatch(setUserProdCartItems(ids));
        if (typeof callbackFunction === 'function') callbackFunction()
      }
    } catch (error) {
      dispatch(hideLoader())
      console.log(error);
    }

  }

  /** remove wishlist item */
  const removeFromWishlist = async (ev: MouseEvent<HTMLButtonElement>, api: any) => {
    ev.stopPropagation()
    dispatch(showLoader(message.REMOVING_FROM_WISHLIST))
    const response = await postDetails(APIList.REMOVE_FROM_WISHLIST, { groupId: api.group_id, groupVersionId: api.group_version_id }, () => removeFromWishlist(ev, api))
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      let filtered = wishListedItems.filter((item: any) => item !== api.group_version_id)
      let filteredList = list.filter((item: any) => item.group_version_id !== api.group_version_id)
      dispatch(setWishListedItems(filtered))
      callbackFunction(filteredList)
    }
    dispatch(hideLoader())
  }

  /** remove wishlist item */
  const moveWishlistToCart = async (ev: MouseEvent<HTMLButtonElement>, api: any) => {
    ev.stopPropagation()

    if (prodCartItems.includes(api.group_version_id)) {
      navigate(NavList.API_LISTING_PRODUCTION);
      return;
    }

    if (prodOrders.includes(api.group_version_id)) {
      dispatch(setSideModalOption("prod"));
      navigate(NavList.ORDERS);
      return;
    }

    if (cartItems.includes(api.group_version_id)) {
      navigate(NavList.CART);
      return;
    }

    if (uatOrders.includes(api.group_version_id)) {
      dispatch(setOrderTab('uat'))
      navigate(NavList.ORDERS);
      return;
    }

    dispatch(showLoader(message.MOVE_CART));
    const response = await postDetails(APIList.SET_CART_ITEM, {
      groupId: api.group_id,
      groupVersionId: api.group_version_id
    }, () => moveWishlistToCart(ev, api));
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      dispatch(setUserCartItems([...cartItems, api.group_version_id]));
      let filtered = wishListedItems.filter((item: any) => item !== api.group_version_id)
      let filteredList = list.filter((item: any) => item.group_version_id !== api.group_version_id)
      dispatch(setWishListedItems(filtered))
      callbackFunction(filteredList)
      navigate(NavList.CART);
    }
    dispatch(hideLoader());
  }

  return (
    <div>
      {Array.isArray(list) && list.length !== 0 && list.map((api) => (
        <div
          onClick={() => handleCardClick(api)}
          className={
            from === "marketplace"
              ? "mf-listing-card-container cursor-pointer bg-white"
              : "mf-listing-card-container bg-white cursor-pointer"
          }
          key={`${Date.now() * (Math.random() * 5)}`}
        >
          <div className="mf-card-shadow mf-common-card position-relative">
            <div className="mf-common-card-padding row no-negative-margin justify-content-between align-items-center">
              <div className="col-12 col-md-6 col-lg-6 ps-0">
                <div className="d-flex align-items-start align-items-md-center align-items-lg-center flex-column flex-md-row flex-lg-row mf-card-left-content mf-card-mob-padd">
                  <img
                    className="devStatusIcons"
                    width={54}
                    height={54}
                    src={stableIcon}
                    alt="stable"
                  />

                  {/* left side content ui block*/}
                  <div className="mf-listing-api ms-md-3 ms-lg-4">
                    <p className="mb-0 text-primary-color font-16 weight-500 d-inline-flex align-items-center flex-wrap">
                      {api.group_name}
                      <span className="ms-4 text-capitalize weight-500">
                        {api.group_type==='e-cas' ? 'Read Only' : api.group_type}
                      </span>
                      {(from === "cart" ||
                        from === "production" ||
                        from === "orders" ||
                        from === "wishlist" ||
                        from === "live" ||
                        from === "checkout") && (
                          <span className="ms-4 weight-500">
                            v
                            {`${api.group_version}`.length === 1
                              ? ` ${api.group_version}.0`
                              : " " + api.group_version}
                          </span>
                        )}
                    </p>
                    {from === "agreements" ? (
                      <p className="mb-0 font-16 weight-400 mf-listing-api-desc mt-1">
                        Effective from {api.effective_since}
                      </p>
                    ) : (
                      <p className="mb-0 font-16 weight-400 mf-listing-api-desc mt-1">
                        {api.api_info}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {from === "cart" && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex align-items-center justify-content-end">
                  <button
                    onClick={(ev) => handleCartItemDelete(ev, api)}
                    type="button"
                    className="border-0 cart-delete-btn"
                  >
                    <img width={17} height={17} src={deleteIcon} alt="delete" />
                  </button>
                </div>
              )}

              {from === "orders" && typeof api?.order_state !== 'undefined' && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex align-items-center justify-content-end card-status-right">
                  {api.order_state.toString() ===
                    UATOrdersStatus.pending && (
                      <button
                        type="button"
                        className="card-status-btn card-status-btn-pending text-capitalize font-14 weight-600"
                      >
                        pending
                      </button>
                    )}
                  {api.order_state.toString() ===
                    UATOrdersStatus.processed && (
                      <button
                        type="button"
                        className="card-status-btn card-status-btn-processed text-capitalize font-14 weight-600"
                      >
                        Processed
                      </button>
                    )}
                  {api.order_state.toString() ===
                    UATOrdersStatus.onhold && (
                      <button
                        type="button"
                        className="card-status-btn card-status-btn-hold text-capitalize font-14 weight-600"
                      >
                        On Hold
                      </button>
                    )}
                  {api.order_state.toString() ===
                    UATOrdersStatus.failed && (
                      <button
                        type="button"
                        className="card-status-btn card-status-btn-failed text-capitalize font-14 weight-600"
                      >
                        Failed
                      </button>
                    )}
                </div>
              )}

              {from === "production" && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex align-items-center justify-content-end">
                  <span
                    title={!api?.threshold_exceed ? "threshold must exceed" : undefined}
                    className="go-live-threshold-tooltip"
                  >
                    <button
                      onClick={(ev) => handleProdClick(ev, api)}
                      disabled={!api?.threshold_exceed}
                      className="go-live-btn border-0 d-flex align-items-stretch vert-middle"
                    >
                      <div className="primary-bg-color">
                        <img width="18" height="18" src={GoLiveIcon} alt="live" />
                      </div>
                      <p className="mb-0 ps-2 pe-4 h-auto text-white text-capitalize font-14 primary-bg-color weight-400">
                        {prodOrders?.includes(api.group_version_id)
                          ? "View order"
                          : prodCartItems?.includes(api.group_version_id) ? "View in Cart" : "Go Live"}
                      </p>
                    </button>
                  </span>
                  <button
                    disabled={!api?.threshold_exceed}
                    type="button"
                    className="prod-i-btn border-0 ms-3"
                  >
                  </button>
                </div>
              )}

              {from === "checkout" && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex checkout-card-actions pe-0">
                  <p className="mb-0 text-capitalize font-12 weight-400">
                    <img
                      className="me-2"
                      width={19}
                      height={19}
                      src={
                        api?.legal_approved
                          ? successOutlineIcon
                          : failureOutlineIcon
                      }
                      alt={api?.legal_approved ? "success" : "failure"}
                    />
                    legal
                  </p>
                  <p className="mb-0 text-capitalize font-12 weight-400 ms-5 mx-md-5 mx-lg-5">
                    <img
                      className="me-2"
                      width={19}
                      height={19}
                      src={
                        api?.commercial_approved
                          ? successOutlineIcon
                          : failureOutlineIcon
                      }
                      alt={api?.commercial_approved ? "success" : "failure"}
                    />
                    commercial
                  </p>
                  <button onClick={(ev) => handleSaveLater(ev, api)} className="save-for-later-btn weight-500 px-2">
                    Save for Later
                  </button>
                </div>
              )}

              {from === "agreements" && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex checkout-card-actions pe-0 position-relative">
                  <button
                    type="button"
                    className="card-status-btn card-status-btn-processed text-capitalize font-14 weight-600 me-3"
                  >
                    {" "}
                    Effective{" "}
                  </button>
                  <button
                    className="agreement-info text-balck border-0 weight-700 position-absolute"
                    type="button"
                  >
                    i
                  </button>
                </div>
              )}

              {from === "wishlist" && (access.hasUATAccess !== false && access.hasProdAccess !== false) && (
                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex wishlist-card-actions pe-0 position-relative justify-content-end pe-4">
                  <button
                    type="button"
                    className="me-3 bg-white border-0 wishlist-add-cart-btn d-flex align-items-center"
                    onClick={(ev) => moveWishlistToCart(ev, api)}
                  >
                    <img className="me-2" width={14} height={14} src={cartBlue} alt="cart" />
                    <p className="mb-0 font-14 weight-500 text-capitalize">
                      {
                        [...cartItems, ...prodCartItems].includes(api.group_version_id) ? "View in Cart"
                          :
                          [...uatOrders, ...prodOrders].includes(api.group_version_id) ? 'View order' : "Add to Cart"
                      }
                    </p>
                  </button>

                  <button
                    onClick={(ev) => removeFromWishlist(ev, api)}
                    type="button"
                    className="border-0 cart-delete-btn"
                  >
                    <img width={17} height={17} src={deleteIcon} alt="delete" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      <Share route='api' show={showShare} callback={() => {
        setShowShare(false)
        setSelectedID('')
      }} id={selectedID} />

      <BillingInfoModal
        show={showBillingModal}
        onClose={() => setShowBillingModal(false)}
        initialData={billingForm || undefined}
        onSubmit={handleBillingSubmit}
      />
    </div>
  );
};

export default Card;
